import { render } from "./ProjectGallery.vue?vue&type=template&id=4bd0f433"
import script from "./ProjectGallery.vue?vue&type=script&lang=js"
export * from "./ProjectGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__